exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".father-box[data-v-256ce8bb]{background:#fff;padding-bottom:10px}[data-v-256ce8bb] .el-carousel__button{width:6px}[data-v-256ce8bb] .el-carousel__indicator--horizontal{padding:3px 4px}.esp-text[data-v-256ce8bb]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
